export class LivestockPurchasers {
    id: string = '';    
    quote_id: string = '';  
    first_name: string = '';  
    last_name: string = '';  
    email: string = '';  
    postcode: string = '';  
    ownership: number = null;  
}
